const scene_data = {
  intro: {
    title: "Introduction",
    media: [require('@/assets/audio/WelcomeHome.mp3')],
    trackPostTime: 1*60+34,
    cover: require('@/assets/covers/Welcome.jpg'),
  },
  bathroom: {
    title: "Bathroom",
    media: [require('@/assets/audio/Bathroom.mp3')],
    trackPostTime: 4*60+18,
    cover: require('@/assets/covers/Bathroom.jpg'),
  },
  office: {
    title: "Office",
    media: [require('@/assets/audio/Office.mp3')],
    trackPostTime: 5*60+28,
    cover: require('@/assets/covers/Office.jpg'),
  },
  kitchen: {
    title: "Kitchen",
    media: [require('@/assets/audio/Kitchen.mp3')],
    trackPostTime: 6*60+38,
    cover: require('@/assets/covers/Kitchen.jpg'),
  },
  living: {
    title: "Living Room",
    media: [require('@/assets/audio/LivingRoom.mp3')],
    trackPostTime: 5*60+45,
    cover: require('@/assets/covers/LivingRoom.jpg'),
  },
  bedroom: {
    title: "Bedroom",
    media: [require('@/assets/audio/Bedroom.mp3')],
    trackPostTime: 8*60+36,
    cover: require('@/assets/covers/Bedroom.jpg'),
  },
  finale1: {
    title: "The Table",
    media: [require('@/assets/audio/Finale1.mp3')],
    trackPostTime: 1*60+31,
    cover: require('@/assets/covers/Finale1.jpg'),
  },
  finale2: {
    title: "Finale",
    media: [require('@/assets/audio/Finale2.mp3')],
    trackPostTime: 0,
    cover: require('@/assets/covers/Finale2.jpg'),
  },
};
exports.scene_data = scene_data;

const early_audio = 
    [
      require('@/assets/audio/Guidelines.mp3'),
    ];
exports.early_audio = early_audio;
const late_audio = 
    [
      require('@/assets/audio/Credits.mp3'),
    ];
exports.late_audio = late_audio;

const scene_orders = {
  1: ["intro", "kitchen", "living", "office", "bathroom", "bedroom", "finale1", "finale2"],
  2: ["intro", "living", "office", "bathroom", "kitchen", "bedroom", "finale1", "finale2"],
  3: ["intro", "office", "bathroom", "kitchen", "living", "bedroom", "finale1", "finale2"],
  4: ["intro", "bathroom", "kitchen", "living", "office", "bedroom", "finale1", "finale2"],
};
exports.scene_orders = scene_orders;